export const APPLICATION_CONTAINER_INITIALIZED = 'APPLICATION_CONTAINER_INITIALIZED';
export const APPLICATION_CONTAINER_SET_CONFIG = 'APPLICATION_CONTAINER_SET_CONFIG';

export function applicationInitialized() {
    return {
        type: APPLICATION_CONTAINER_INITIALIZED
    };
}

export function setApplicationConfig(config){
    return {
        type: APPLICATION_CONTAINER_SET_CONFIG,
        payload: config
    };
}
